import { useMemo } from 'react';

import { useAuth } from 'modules/auth/hooks/useAuth';
import { useUser } from 'modules/user/hooks/useUser';
import { useEmailData } from 'modules/auth/hooks/useEmailData';

import { getAccountName } from '../utils/getAccountName';

export const usePersonalAccountButton = () => {
  const { confirmedEmail } = useEmailData();
  const { address, email, nickname } = useUser();
  const { authProvider, isOAuth } = useAuth();

  const accountName = useMemo(
    () =>
      getAccountName({
        address,
        authProvider,
        email: confirmedEmail || email,
        isOAuth,
        nickname,
      }),
    [address, authProvider, confirmedEmail, email, isOAuth, nickname],
  );

  return { accountName };
};
